import { render, staticRenderFns } from "./qianlima-news.vue?vue&type=template&id=1489f4fc&"
import script from "./qianlima-news.js?vue&type=script&lang=js&"
export * from "./qianlima-news.js?vue&type=script&lang=js&"
import style0 from "./qianlima-news.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports